import { useState, useRef, useEffect, ReactNode } from 'react'
import { Button } from './Button'

interface DropdownItem {
  label: string
  href?: string
  onClick?: () => void
  type?: 'divider'
}

interface DropdownProps {
  trigger: ReactNode
  items: DropdownItem[]
}

export const Dropdown = ({ trigger, items }: DropdownProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <div ref={ref} className="relative">
      <div onClick={() => setIsOpen(!isOpen)} className="cursor-pointer">
        {trigger}
      </div>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
          {items.map((item, index) => {
            if (item.type === 'divider') {
              return <div key={index} className="border-t border-gray-200 my-2" >{item.label}</div>
            }

            return (
              <Button
                key={index}
                onClick={() => {
                  item.onClick?.()
                  setIsOpen(false)
                }}
                variant="ghost"
                size="sm"
                className="w-full justify-start px-4 py-2"
              >
                {item.label}
              </Button>
            )
          })}
        </div>
      )}
    </div>
  )
}
